import React, { useEffect, useMemo, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { getCategories } from "../../../slices/2-category/thunk";

const CreateRankedModal = ({ isOpen, toggle, onSubmit }) => {
    const dispatch = useDispatch();

    const categories =
        useSelector((state) => state.Categories.categories) || [];

    useEffect(() => {
        if (isOpen) {
            dispatch(getCategories({ page: 1, limit: 100 }));
        }
    }, [isOpen, dispatch]);

    const [form, setForm] = useState({
        name: "",
        questionCount: "",
        maxPlayers: "",
        timePerQuestionSec: 10,
        isPublic: true,
        category1: null,
        category2: null,
        category3: null,
    });

    const handleChange = (key, value) => {
        setForm((prev) => ({ ...prev, [key]: value }));
    };

    // convert to react-select options
    const allOptions = useMemo(() => {
        return categories.map((cat) => ({
            value: cat._id,
            label: cat.name,
        }));
    }, [categories]);

    // selected ids
    const selected = {
        c1: form.category1?.value,
        c2: form.category2?.value,
        c3: form.category3?.value,
    };

    // smart filter (exclude selected in other selects)
    const getFilteredOptions = (exclude = []) => {
        return allOptions.filter((opt) => !exclude.includes(opt.value));
    };

    const handleSubmit = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        const questionCount = Number(form.questionCount);
        const timePerQuestion = Number(form.timePerQuestionSec);

        if (!form.name) {
            alert("من فضلك كمل البيانات");
            return;
        }

        // if (!form.category1 || !form.category2 || !form.category3) {
        //     alert("لازم تختار 3 تصنيفات");
        //     return;
        // }

        // عدد الأسئلة
        if (questionCount < 10 || questionCount > 50) {
            alert("عدد الأسئلة لازم يكون من 10 إلى 50");
            return;
        }

        // وقت السؤال
        if (timePerQuestion < 7) {
            alert("وقت السؤال لازم يكون 7 ثواني على الأقل");
            return;
        }

        const payload = {
            name: form.name,
            categoryId_1: form.category1?.value,
            categoryId_2: form.category2?.value,
            categoryId_3: form.category3?.value,
            questionCount,
            maxPlayers: Number(form.maxPlayers),
            timePerQuestionSec: timePerQuestion,
            isPublic: form.isPublic,
        };

        onSubmit(payload);
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>إنشاء بطولة جديدة</ModalHeader>

            <form onSubmit={handleSubmit}>
                <ModalBody>

                    {/* Name */}
                    <div className="mb-3">
                        <label>اسم البطولة</label>
                        <input
                            className="form-control"
                            value={form.name}
                            onChange={(e) => handleChange("name", e.target.value)}
                            required
                        />
                    </div>

                    {/* Questions */}
                    <div className="mb-3">
                        <label>عدد الأسئلة</label>
                        <input
                            type="number"
                            min={10}
                            max={50}
                            className="form-control"
                            value={form.questionCount}
                            onChange={(e) => handleChange("questionCount", e.target.value)}
                        />
                    </div>

                    {/* Players */}
                    <div className="mb-3">
                        <label>عدد اللاعبين</label>
                        <input
                            type="number"
                            className="form-control"
                            value={form.maxPlayers}
                            min="1"
                            onChange={(e) =>
                                handleChange("maxPlayers", e.target.value)
                            }
                        />
                    </div>

                    <div className="mb-3">
                        <label>الوقت لكل سؤال (بالثواني)</label>
                        <input
                            type="number"
                            min={7}
                            className="form-control"
                            value={form.timePerQuestionSec}
                            onChange={(e) => handleChange("timePerQuestionSec", e.target.value)}
                        />
                    </div>

                    {/* Category 1 */}
                    {/* <div className="mb-3">
                        <label>التصنيف الأول</label>
                        <Select
                            placeholder="اختر التصنيف الأول"
                            value={form.category1}
                            onChange={(val) => handleChange("category1", val)}
                            options={getFilteredOptions([
                                selected.c2,
                                selected.c3,
                            ])}
                        />
                    </div> */}

                    {/* Category 2 */}
                    {/* <div className="mb-3">
                        <label>التصنيف الثاني</label>
                        <Select
                            placeholder="اختر التصنيف الثاني"
                            value={form.category2}
                            onChange={(val) => handleChange("category2", val)}
                            options={getFilteredOptions([
                                selected.c1,
                                selected.c3,
                            ])}
                        />
                    </div> */}

                    {/* Category 3 */}
                    {/* <div className="mb-3">
                        <label>التصنيف الثالث</label>
                        <Select
                            placeholder="اختر التصنيف الثالث"
                            value={form.category3}
                            onChange={(val) => handleChange("category3", val)}
                            options={getFilteredOptions([
                                selected.c1,
                                selected.c2,
                            ])}
                        />
                    </div> */}

                </ModalBody>

                <ModalFooter>
                    <button className="btn btn-success px-4" type="submit">
                        إنشاء
                    </button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default CreateRankedModal;